export default "__VITE_ASSET__CTctPBIE__"